import React, { useEffect, useRef } from "react"
import { AiOutlineClose } from "react-icons/ai"
import { AiOutlineHeart } from "react-icons/ai"

import useGlobalContext from "../context/GlobalContext"

const WishList = () => {
  const containerRef = useRef(null)
  const cartOutside = useRef(null)
  const { openWishList, setOpenWishList } = useGlobalContext()

  useEffect(() => {
    const ref = containerRef.current
    const checkClickBoundary = (e) => {
      if (
        (ref == null || ref?.contains(e.target)) &&
        !cartOutside.current.contains(e.target)
      )
        return
      setOpenWishList(false)
    }

    ref?.addEventListener("click", checkClickBoundary)

    return () => {
      ref?.removeEventListener("click", checkClickBoundary)
    }
  }, [setOpenWishList])

  return (
    <div
      className={`cart-container ${openWishList ? "show" : ""}`}
      ref={containerRef}
    >
      <div className="cart-container-c" ref={cartOutside}></div>
      <div className="cart-content">
        <div className="cart-header">
          <h4>
            <AiOutlineHeart />
            Your Wishlist
          </h4>
          <button onClick={() => setOpenWishList(false)} className="close">
            close <AiOutlineClose />
          </button>
        </div>
        <div className="cart-body">
          <div className="cart-body-empty">
            <p>You must be logged in to see your wishlist</p>
            <button
              onClick={() => setOpenWishList(false)}
              className="btn-cta danger"
            >
              Back to shop
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default WishList
